module.exports = __webpack_public_path__ + "fonts/whitneysemibold.woff";